import React, { useState, useEffect } from 'react';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { useReactMediaRecorder } from "react-media-recorder";
import Confirm from '../lib/confirm';

const Kidscreator = ({ dataprovider, userinfo, is_dev, setToken }) => {
  const [project, setProject] = useState({id:0,name:'',edit:0});
  const [tracks, setTracks] = useState([]);
  const [nameDirty, setNameDirty] = useState(false);
  const [trackNameDirty, setTrackNameDirty] = useState([]);
  const [audio] = useState(new Audio());
  const [playing, setPlaying] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [recInterval, setRecInterval] = useState(null);
  const [recSecounds, setRecSeconds] = useState(0);
  const [checkInternet, setCheckInternet] = useState(false);
  const [confirmMsg, setConfirmMsg] = useState({});

  const doCheckInternet = () => {
    fetch("https://"+dataprovider.apiUrl+'/check.php')
      .then((res) => {
        setCheckInternet(window.setTimeout(doCheckInternet, 10000));
      })
      .catch((error) => {
        console.log('offline');
        setCheckInternet(window.setTimeout(doCheckInternet, 10000));
      })
  }
  
  useEffect(() => {
    if (checkInternet===false) {
      setCheckInternet(window.setTimeout(doCheckInternet, 10000));
    }
  }, []);
  
  
  
  useEffect(() => {
    const loadProject = (data) => {
      if (data.newkids === true) {
        window.location.hash = data.kidscreator;
        setToken(data.kidscreator);
      }
      const n = data.name.split(':');
      if (n.length > 1) {
        data.producer = n[0].trim();
        data.prname = n[1].trim();
      }
      else {
        data.producer = '';
        data.prname = n[0].trim();
      }
      setProject(data);
    }

    dataprovider.getRow('project', 0, '', loadProject);
  }, [dataprovider, setToken]);

  useEffect(() => {
    if (project.id) {
      dataprovider.getList('track', {filter:{id_project:project.id},sort:['pos']}, setTracks);
    }
  }, [dataprovider, project]);
  
  useEffect(() => {
    audio.addEventListener('ended', () => setPlaying(false));
  }, []);  

  const UploadCompleted = (data) => {
    setTracks(data);
    setUploading(false);
  }  
  
  const OnStopRec = (audiourl, audioBlob) => {
    setUploading(true);
    dataprovider.upload('track', 0, audioBlob, UploadCompleted);
  }

  const rmr = useReactMediaRecorder({ audio: true, type: "audio/webm", onStop:OnStopRec})
  const {
    startRecording,
    stopRecording,
//    mediaBlobUrl,
  } = rmr;
  
  const StartStopRec = (ev) => {
    if (rmr.status==='recording') {
      clearInterval(recInterval);
      stopRecording();
    }
    else {
      setRecSeconds(0);
      setRecInterval(setInterval(() => { setRecSeconds(recSecounds => recSecounds + .2); }, 200));
      startRecording();
    }
  }
  
  const PlayAudio = (k) => (ev) => {
    if (playing!==false) {
      setPlaying(false);
      audio.pause();
    }
    else {
      setPlaying(k);
      audio.src = tracks[k].docurl;
      audio.load();
      audio.play();
    }
  }
  
  const HandleNameChange = (key) => (ev) => {
    const v = ev.target.value;
    var name = (key==='producer'?v:project.producer)+': '+(key==='prname'?v:project.prname);
    if (name.substr(0,1)===':') {
      name = name.substr(1).trim();
    }
    setProject((pr)=>({...pr, [key]:v, name: name }));
    if (nameDirty) {
      clearTimeout(nameDirty);
    }
    setNameDirty(setTimeout(PostNameChange.bind(null, name), 1000));
  }
  const PostNameChange = (name) => {
    console.log(name);
    setNameDirty(false);
    dataprovider.update('project', {id:project.id, name:name}, null);
  }

  const HandleTrackNameChange = (k) => (ev) => {
    const rows = [...tracks];
    const row = {...rows[k]};
    row.name = ev.target.value;
    rows[k] = row;
    setTracks(rows);
    if (trackNameDirty[k]) {
      clearTimeout(trackNameDirty[k]);
    }
    const dirtylist = [...trackNameDirty];
    dirtylist[k] = setTimeout(PostTrackNameChange.bind(null, k, ev.target.value), 1000)
    setTrackNameDirty(dirtylist);
  }
  const PostTrackNameChange = (k, name) => {
    const dirtylist = [...trackNameDirty];
    dirtylist.splice(k,1);
    setTrackNameDirty(dirtylist);
    dataprovider.update('track/'+tracks[k].id, {id:tracks[k].id, name: name, filter:{id_project:project.id}}, setTracks);
  }

  const DeleteTrack = (k) => (ev) => {
    setConfirmMsg({msg:'Wirklich löschen?|', setMsg: setConfirmMsg, 
      buttons:[{text:'Abbrechen'},{typ:'primary',text:'Track löschen', action:DeleteTrack2(k)}]});  
  }

  const DeleteTrack2 = (id) => (ev) => {
    dataprovider.del('track/'+id, {filter:{id_project:project.id}}, setTracks);
    setConfirmMsg({});
  }


  const FormatTime = (t) => {
    var s = '';
    s += ('0'+Math.floor(t/60)).slice(-2);
    s += ':';
    s += ('0'+(Math.floor(t)%60)).slice(-2);
    s += '.';
    s += (''+t).slice(-1);
    return s;
  }
  
  const grid=8;
  const getItemStyle = (isDragging, draggableStyle) => ({
    // some basic styles to make the items look a bit nicer
    userSelect: "none",
    // styles we need to apply on draggables
    ...draggableStyle
  });
  const getListStyle = isDraggingOver => ({
    background: isDraggingOver ? "#eee" : "",
    padding: grid,
  });  
  const onDragEnd = (result) => {
    const max = tracks.length - 1;
    const src = max - result.source.index;
    const dst = max - result.destination.index;
    if (!result.destination || src===dst) {
      return;
    }
    const srcpos = tracks[src].pos;
    const dstpos = tracks[dst].pos;
    setTracks(tr=>{
      const tr2 = JSON.parse(JSON.stringify(tr));
      if (dst >= tr2.length) {
        tr2.push(undefined);
      }
      tr2.splice(dst, 0, tr2.splice(src, 1)[0]);
      return tr2;
    })
    
    dataprovider.update('track/'+srcpos, {move:dstpos, filter:{id_project:project.id}}, setTracks);
  }

  const rtracks = [...tracks].reverse();
  return (
    <div className="container kidscreator" style={{maxWidth:'576px', backgroundColor:'#FFF', minHeight:'100vh'}}>
      <img src={process.env.PUBLIC_URL+"/kids-kombi.svg"} style={{width:'100%'}} alt="KistCreator Logo" />
      <table>
        <tbody className="kchead">
          <tr>
            <td></td>
            <td><input name="projname" placeholder="Projektname" value={project.prname} onChange={HandleNameChange('prname')} style={{color:nameDirty?'red':''}} /></td>
            <td rowSpan="2">
              <button type="button" className="btn ms-1 py-1 px-2" data-bs-toggle="modal" data-bs-target="#exampleModal" title="Info">
                <i className="bi bi-info-circle fs-4"></i>
              </button>
            </td>
            <td>
            </td>
          </tr>
          <tr>
            <td></td>
            <td><input name="producer" placeholder="Produzent*in (optional)" value={project.producer} onChange={HandleNameChange('producer')} style={{color:nameDirty?'red':''}} /></td>
            <td></td>
          </tr>
        </tbody>
      </table>
    {window.navigator.onLine === false ?
      <div className="p-3 m-2 text-center fs-3" style={{backgroundColor:'#DC3545', color:'#FFF', borderRadius:'6px'}}>Keine Internet Verbindung!</div>
    :                                    
      <div className="text-center mb-2 mt-4">
        <div className="d-inline-flex align-items-center">
          <img src={process.env.PUBLIC_URL + "/img/"+(rmr.status==='recording'?'stop':'record')+".svg"} onClick={StartStopRec} style={{cursor:'pointer'}} alt="Start/Stop recording" />
          <div style={{minWidth:'7rem'}}>
      {uploading && 
            <div className="spinner-border ms-4" style={{width: '3rem', height: '3rem'}} role="status">
              <span className="visually-hidden">Loading...</span>
            </div> 
      }
      {!uploading &&  
            <div className="ps-4 fs-3 stdf">{rmr.status==='recording'?FormatTime(recSecounds):'00:00.0'}</div>
      }
          </div>
        </div>
      </div>
    }
      <DragDropContext onDragEnd={onDragEnd}>
        <Droppable droppableId="droppable">
          {(provided, snapshot) => (
            <div className="container"
              {...provided.droppableProps}
              ref={provided.innerRef}
              style={getListStyle(snapshot.isDraggingOver)}> 
    {rtracks.map((tr, i)=> {
      if (rtracks.length===1 && !rtracks[0].duration) return null;
      const k = rtracks.length-i-1;
      return (
            <Draggable key={tr.id} draggableId={String(tr.id)} index={i}>
              {(provided, snapshot) => (
              <div className="d-flex mb-1 mt-1"
                ref={provided.innerRef}
                  {...provided.draggableProps}
                  style={getItemStyle(
                    snapshot.isDragging,
                    provided.draggableProps.style
                  )}>
                <div className="col-auto p-0 d-flex align-items-center" {...provided.dragHandleProps} title="Track verschieben"><i className="bi bi-grip-horizontal fs-3"></i></div>
                <div className="col-auto p-0 d-flex align-items-center justify-content-center mx-2 stdf " style={{minWidth:'25px', color:'#888'}}>
                  {k===0?<i className="bi bi-power fs-5"/>:('0'+k).substr(-2)}</div>
                <div className="col-4 flex-grow-1 d-flex align-items-center"><input value={tr.name} placeholder="Titel" onChange={HandleTrackNameChange(k)} style={{color:trackNameDirty[k]?'red':'', width:'100%'}} /></div>
                <div className="col-auto p-0" style={{width:'50px'}}>
        {tr.duration>0 && 
                  <button type="button" className="btn ms-1 pt-1 px-2" onClick={PlayAudio(k)} title={playing===k?"Abspielen stoppen":"Track abspielen"}><i style={{fontSize:'2rem'}} className={"bi bi-"+(playing===k?"stop":"play")+"-fill"}></i></button>
        }
                </div>
        {k>0 &&
                <div className="col-auto p-0"><button type="button" style={{marginTop:'0.1em'}} className="btn ms-1 py-1 pt-2 pb-1" onClick={DeleteTrack(tr.id)} title="Track löschen"><i style={{fontSize:'1.5rem'}} className="bi bi-trash"></i></button></div>
        }
              </div>
            )}
            </Draggable>                  
    )})}  
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
      <Confirm msg={confirmMsg.msg} setMsg={setConfirmMsg} buttons={confirmMsg.buttons} />
      <div className="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">KIDSCreator</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
              Das Projekt ist mit {project.username} verknüpft.
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Kidscreator;
